import { RootState } from 'store/ducks';
import TicketServices from './ticket.service';
import { IOrders } from 'models/Order';
import toast from 'components/Toast/dispatch';
import iconDeliveryForecast from 'img/icon-delivery-forecast.svg';

export default class CreateProtocolServices {
    static isAutoAttendanceProtocolDisabled = (user?: RootState['user']) => {
        return user?.disableAutoAttendanceProtocolOnDownload === true;
    };

    static showUnavailableDeliveryForecastInfo = (orderNumber?: string) => {
        const message = orderNumber
            ? `Não foi possível consultar a previsão de entrega do pedido ${orderNumber}. Para mais informações, entre em contato com o SAC.`
            : 'Não foi possível consultar a previsão de entrega deste pedido. Para mais informações, entre em contato com o SAC.';

        toast.info('Previsão de entrega', message, iconDeliveryForecast, 'Fechar');
    };

    static showDelayedDeliveryForecastInfo = (orderNumber?: string) => {
        const message = orderNumber
            ? `Identificamos que o pedido ${orderNumber} está com a entrega atrasada. Para mais informações, entre em contato com o SAC.`
            : 'Identificamos que este pedido está com a entrega atrasada. Para mais informações, entre em contato com o SAC.';

        toast.info('Previsão de entrega', message, iconDeliveryForecast, 'Fechar');
    };

    createProtocol = async (order: IOrders, user: RootState['user']) => {
        const _ticketService = new TicketServices();

        const item: any = {
            protocolNumber: 0,
            legalPerson: order.company?.personType === "Juridica" ? 1 : 2,
            communicationChannel: "PORTAL_CC",
            protocolCategory: "LOGISTICA",
            ticketReason: "PREVISÃO DE ENTREGA",
            contactName: user?.fullName,
            contactMailAddress: user?.email,
            contactPhoneNumber: user?.phoneNumber,
            order: order,
            description: `Solicitação do tracking do pedido: ${order.protheusOrderSale}.`,
            tags: ["TRACKING DO PEDIDO", "SOLICITAÇÃO", "2A_VIA", "CUSTOMER_CARE"],
            linkTicketIdentifier: "",
            customerId: order.customerId,
            customerName: user?.fullName,
            attendenceType: "SELF_SERVICE"
        };

        const response = await _ticketService.create(item);

        if (response.status === 200) {
            const { data } = response.data;
            toast.success(`O protocolo ${data.protocolNumber} foi registrado com sucesso`);
        } else {
            toast.error('Ocorreu um erro durante a requisição');
        }
    };
}